<template>
    <main class="page">
        <!-- Banner -->
        <motor-banner  v-if="main" :bgimg="{
            src: env.imageUrl + main.banner.banner_news.image,
            loading: env.imageUrl + main.banner.banner_news.thumb_image,
        }" title="our news" />
        <!-- Section -->
        <section class="section section--news" v-if="getNews.length">
            <div class="motor-container">
                <div class="category-chooser">
                    <div class="container">
                        <v-select 
                            :options="[{id: 0, name: 'All'}].concat(categories)"
                            label="name"
                            v-model="category"
                            @input="setSelected" />
                    </div>
                </div>
                <router-link :to="'/news/' + news.id" class="article" v-for="news in getNews" :key="news.id">
                    <div class="wrapper">
                        <img v-lazy="{
                            src: env.imageUrl + news.image,
                            loading: env.imageUrl + news.thumb_image,
                        }" alt="media">
                    </div>
                    <h3>{{news.title}}</h3>
                    <div class="info">
                        <div class="txt author">{{news.author}}</div>
                        <div class="devider"></div>
                        <div class="txt category">{{news.category}}</div>
                        <div class="devider"></div>
                        <div class="txt date">{{news.date | formatDate}}</div>
                    </div>
                    <p>{{news.short_text}}</p>
                </router-link>
            </div>
            <!-- Pagination -->
            <div class="pagination">
                <paginate
                    v-model="page"
                    :pageCount="getNewsTotal"
                    :pageRange="1"
                    :marginPages="2"
                    :clickHandler="onClick"
                    :prevText="'<<'"
                    :nextText="'>>'"
                    :containerClass="'pagination-container'"
                    :page-class="'page-item'"
                ></paginate>
            </div>
        </section>
        <section class="section section--loading" v-else>
            <div class="loading--icon"></div>
        </section>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import { env } from '../enviorments'
import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'

export default {
    name: 'news',
    components: {
        MotorBanner,
    },
    computed: {
        ...mapState({
            main: state => state.main,
            categories: state => state.categories,
        }),
        ...mapGetters([
            'getNews',
            'getNewsTotal',
        ])
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
            callNews: 'callNews',
            callCategory: 'callCategory',
        }),
        setSelected(value) {
            this.category = value
            this.callNews({index: 1, category_id: value.id})
        },
        async onClick() {
            await this.callNews({index: this.page})
            console.log(this.getNews)
        }
    },
    data() {
        return {
            BannerImg,
            page: 1,
            env,
            category: {
                id: 0,
                name: 'All',
            }
        }
    },
    async mounted() {
        if (!this.categories) await this.callCategory()
        if (!this.main) await this.callMain()
        await this.callNews({index: this.page})
        console.log(this.getNews)
    },
}
</script>

<style lang="scss" scoped>
.page {
    .section--news {
        padding-top: 40px;
        padding-bottom: 40px;
        .category-chooser {
            width: 100%;
            padding: 0 10px;
            .container {
                width: 100%;
                max-width: 400px;
            }
        }
        .pagination {
            display: flex;
            justify-content: center;
            padding: 20px 0;
        }
    }
    .section--loading {
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
